import React, { useEffect, useState } from "react";
import {
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Table,
} from "@material-ui/core";
import moment from "moment";

import firebase from "../store/Firestore";
import { useTranslation } from "react-i18next";

export const SignTable = () => {
  const [signs, setSigns] = useState<any>();
  const { t } = useTranslation();

  useEffect(() => {
    const db = firebase.firestore();

    db.collection("sign").onSnapshot(
      { includeMetadataChanges: false },
      (snapshot) => {
        const s: any = [];
        snapshot.forEach((snap) => {
          s.push({
            id: snap.id,
            name: snap.data().name,
            type: snap.data().type,
            street: snap.data().street,
            time: moment(snap.data().time),
          });
        });
        setSigns(s);
        console.log(s);
      }
    );
  }, []);
  console.log(signs);

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>{t("Sign name")}</TableCell>
          <TableCell>{t("Street")}</TableCell>
          <TableCell>{t("Sign type")}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {signs?.map((row: any) => (
          <TableRow key={row.id}>
            <TableCell component="th" scope="row">
              {row.name}
            </TableCell>
            <TableCell>{row.street}</TableCell>
            <TableCell>{row.type}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
